document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector('#filters');

  menu.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      const li = e.target.closest('li');
      if (li && menu.contains(li)) {
        e.preventDefault();
        const input = li.querySelector('input');
        if (input) input.click();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    // verificar si el evento ocurrió dentro de un swatches-container
    const container = e.target.closest('.productitem--bought-swatches-color');
    if (!container) return;
    // solo actuar sobre TAB
    if (e.key !== 'Tab' || e.shiftKey ) return;
    const radios = [...container.querySelectorAll('input[type="radio"]')];
    const index = radios.indexOf(document.activeElement);

    // si el focus está en uno de los radios
    if (index >= 0 && index < radios.length - 1 ) {
      e.preventDefault();

      // calcular el siguiente radio
      const next = e.shiftKey ? index - 1 : index + 1;

      if (radios[next]) {
        radios[next].focus();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    // solo continuar si el target es uno de los títulos
    const title = e.target.closest('.productitem-bought--title');
    if (!title) return;

    if ((e.key === 'Tab' || e.keyCode === 9) && !e.shiftKey) {
      const container = title.closest('.productitem--info.productitem-bought--info');
      const firstSwatch = container?.querySelector('.productitem--swatches-input');

      if (firstSwatch) {
        e.preventDefault();
        firstSwatch.focus();
      }
    }
  });


});
